import React from 'react';

import { clsx } from 'js/app/utils/clsx.util';

import style from '../../InputDate.scss';
import InputShallowStyle from 'js/app/components/common/Fields/Input/components/InputShallow/InputShallow.scss';

export const InputDateDefault = ({ ...props }) => (
    <input
        className={clsx(InputShallowStyle.input, style.input)}
        maxLength="10"
        type="date"
        data-testid="InputDate_default"
        {...props}
    />
);
